export const ItemTypes = {
  CARD: 'card',
  DIM: 'dimension',
  FILTER: 'filter',
  METRIC: 'metric',
};

export default ItemTypes;
